import React from 'react';
import { ModalHeader } from '@planne-software/uni/Modal';

import { useTranslate } from '@src/core/hooks';
import { Terms } from '@src/features/terms';

import { Modal, TermsModalBody, TermsModalContent } from '../../styles';
import type { TermsDocumentTypeEnum } from './useTermsAcceptance';

type TermsDocumentModalProps = {
  type: TermsDocumentTypeEnum;
  onClose: () => void;
};

export const TermsDocumentModal = (props: TermsDocumentModalProps) => {
  const { type, onClose } = props;
  const { i18n } = useTranslate();

  return (
    <Modal open onClose={onClose}>
      <TermsModalContent data-testid={`signup-terms-modal-${type}`}>
        <ModalHeader title={i18n(type)} divider align='left' onClose={onClose} />

        <TermsModalBody>
          <Terms type={type} />
        </TermsModalBody>
      </TermsModalContent>
    </Modal>
  );
};

export default TermsDocumentModal;
